﻿import { Injectable } from '@angular/core';
//import { Http, Response, Headers } from '@angular/http';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/toPromise';
import { Router } from '@angular/router';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { utils } from '../utils/utils';
import { map } from 'rxjs/operators';
import { ResponseType } from '@angular/http';
import { environment } from 'src/environments/environment';
import { FileModel } from '../models/file-model';

@Injectable()
export class fcGeneral {
    public _utils: utils;

    public headers = new HttpHeaders({
        'Content-Type': 'application/json; charset=utf-8',
        'Accept': 'application/json, text/javascript, /;',
        'idEmpresa': '' + +sessionStorage.getItem("idEmpresa"),
        'idUsuario': '' + +sessionStorage.getItem("idUsuario"),
        'idArea': '1'
        //'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE,PATCH,OPTIONS',
        //'xhrFields' : '{withCredentials : true}'
    });
    public headersImpresion = new HttpHeaders({
        'Content-Type': 'application/pdf',
        'Accept': 'text/html,application/xhtml+xml,application/xml;q=0.9,image/webp,image/apng,*/*;q=0.8,application/signed-exchange;v=b3'
    })

    constructor(private _http: HttpClient, private router: Router) {
        this._utils = new utils();
    }

    /**
     * Realiza una metodo GET del web service
     * @param serviceName Nombre del servicio web
     * @param funcName Metodo de la peticion
     */
    public get(serviceName: string, funcName: string): Observable<any> {
        return this._http.get(this._utils.url + serviceName + '/' + funcName, { headers: this.headers }).pipe(
            map((res: any) => {
            return res;
        }));
    }

    /**
     * Realiza una metodo GET del web service
     * @param serviceName Nombre del servicio web
     * @param funcName Metodo de la peticion
     */
    public getAPI(serviceName: string, funcName: string, params?: HttpParams): Observable<any> {
        return this._http.get(this._utils.url + serviceName + '/' + funcName, { headers: this.headers, params: params }).pipe(
            map((res: any) => {
                return JSON.parse(res);
            }));
    }

    /**
     * Realiza una metodo POST del web service
     * @param serviceName Nombre del web service
     * @param funcName Metodo de la peticion
     */
    public post(serviceName: string, funcName: string, params: any): Observable<any> {
        let json = JSON.stringify(params);

        return this._http.post(this._utils.url + serviceName + '/' + funcName, json, { headers: this.headers }).pipe(
            map((res: any) => {
            return JSON.parse(res.json());
        }));
    }

    /**
     * Realiza una metodo POST del web service
     * @param serviceName Nombre del web service
     * @param funcName Metodo de la peticion
     */
    public postAPI(serviceName: string, funcName: string, body: any, params?:any): Observable<any> {
        //let json = JSON.stringify(params);

        return this._http.post(this._utils.url + serviceName + '/' + funcName, body, { headers: this.headers, params: params}).pipe(
            map((res: any) => {
                return JSON.parse(res);
            }));
    }

    /**
     * Realiza una metodo POST del web service
     * @param serviceName Nombre del web service
     * @param funcName Metodo de la peticion
     */
         public postAPIObject(serviceName: string, funcName: string, body: any, params?:any): Observable<any> {    
            return this._http.post(this._utils.url + serviceName + '/' + funcName, body, { headers: this.headers, params: params}).pipe(
                map((res: any) => {
                    return res;
                }));
        }

    /**
     * Obtiene una archivo desde una dirección url
     * @param serviceName Nombre del web service
     * @param funcName Metodo de la peticion
     * @param url Dirección url del archivo 
     */

    public async getFileAsText(serviceName: string, funcName: string, id: string): Promise<string> {
        let headers = new HttpHeaders({
            'Access-Control-Allow-Origin': '*',
            "objectId": id
        });
        return new Promise<string>((resolve, reject) => {
            return this._http.get(this._utils.url + serviceName + '/' + funcName, { headers: headers, responseType: 'text' }).subscribe( res => resolve(res));
                
        });
    }

    public async getFile(serviceName: string, funcName: string, headers: HttpHeaders): Promise<FileModel> {
        return new Promise<FileModel>((resolve, reject) => {
            this._http.get(this._utils.url + serviceName + '/' + funcName, { headers: headers, responseType: 'json' }).subscribe( 
                res => resolve(<FileModel>res),
                err => reject(null));                
        });
    }


    /**
     * Obtiene una archivo local desde una referencia uri
     * @param localPath Ruta del archivo
     */
    public async getLocalFileAsText(localPath: string): Promise<string> {        
        return new Promise<string>((resolve, reject) => {            
            this._http.get(localPath, { responseType:'text' }).subscribe(
                result => resolve(result),
                error => reject(error))                
        });
    }


    public async sendEmail(body: any) : Promise<any> {
      return new Promise ((resolve, reject) => {
        this._http.post(environment.sendEmailConnection, body, { headers: this.headers }).subscribe(
                result => resolve(result),
                error => reject(error)                
        );
      })
    }

    public async loadFileToStorage(serviceName: string, functionName: string, file: File): Promise<any> {
        let formParams: { append(param: string, value: any, name: string): void; };
        formParams = new FormData();
        let headers = new HttpHeaders({
            'Content-Type': 'multipart/form-data; boundary=<calculated when request is sent>',
            'Accept': '*/*'    
        })

        formParams = formParams.append('file', <any>file, "filename") as any || formParams;

        return new Promise((resolve, reject) => {
            this._http.request<any>('post',`${this._utils.url}${serviceName}/${functionName}`,
            {
                body: formParams,
                //withCredentials: this.configuration.withCredentials,
                headers: headers,
                //observe: observe,
                //reportProgress: reportProgress
            }).subscribe(
                result => resolve(result),
                error => reject(error)
            );
        });
    }

}